<template>
  <div>
    <h2>팝업</h2>
    <div class="card mt-5">
      <div class="card-body" v-if="popup">
        <dl class="row">
          <dt class="col-sm-3">이름</dt>
          <dd class="col-sm-9">{{popup.name}}</dd>
          <dt class="col-sm-3">기간</dt>
          <dd class="col-sm-9">{{popup.startAt}} - {{popup.endAt}}</dd>
          <dt class="col-sm-3">공개</dt>
          <dd class="col-sm-9">{{popup.status ? '공개' : '비공개'}}</dd>
        </dl>
      </div>
    </div>

    <template v-if="popup && popup.img !== null && popup.img !== ''">
      <h5>팝업 이미지<small class="text-muted ml-3">{{popup.img}}</small></h5>
      <img :src="`${publicPath}upload/popup/${popup.img}`" />
    </template>

    <div class="text-center my-3" v-if="popup">
      <router-link
        tag="button"
        class="btn btn-outline-secondary mx-1"
        :to="{name:'adminPopupEdit', params: {id: popup.id}}">
        수정
      </router-link>
      <button type="button" class="btn btn-outline-danger mx-1" @click="remove">삭제</button>
      <button type="button" class="btn btn-outline-secondary mx-1" @click="$router.back()">목록</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminPopupView',
  data() {
    return {
      popup: null,
    };
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      this.axios.get(`/admin/popup/${this.$route.params.id}`)
        .then(({ data }) => {
          this.popup = data;
        })
        .catch(() => {
          this.$router.push({ name: 'adminPopupList' });
        });
    }
  },
  methods: {
    remove() {
      // eslint-disable-next-line no-restricted-globals,no-alert
      if (confirm('삭제하시겠습니까?')) {
        this.$axios.delete(`/admin/popup/${this.popup.id}`)
          .then(() => {
            this.$router.push({ name: 'adminPopupList' });
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .popup-section {
    position: relative;
    overflow: hidden;
    padding-top: 135px;
    text-align: center;
    line-height: 1.5em;
    background-color: #fafafa;
    height: 940px;
    box-sizing: border-box;
    width: 100%;

    .popup-text-box {
      position: relative;
      z-index: 5;

      .popup-title {
        font-size: 68px;
        color: #0c1e2b;
        font-weight: 700;
        line-height: 1.25em;
      }

      .popup-desc {
        font-size: 32px;
        margin-top: 15px;
        padding: 0 15px;
        color: #0c1e2b;
        font-weight: 500;
        line-height: 1.35em;
      }
    }

    .popup-btn {
      display: inline-block;
      position: relative;
      margin-top: 35px;
      width: 360px;
      height: 84px;
      line-height: 84px;
      font-size: 26px;
      color: #0c1e2b;
      font-weight: 700;
      text-align: center;
    }

    .popup-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #000;
      background-position: center;
      background-size: cover;
    }
  }
</style>
